import { reflectKeys } from "@utils/key.reflactor";

export const SEARCH_CHARACTER_LIMIT = 500;

export const SEARCH_PAGE_SIZE = 12;

export const LOCATION = {
  MY_LIBRARY: "My Drive",
  MOE_LIBRARY: "MOE Library",
  COMMUNITY_GALLERY: "Community Gallery",
};

export const LOCATION_TYPE_VALUE = reflectKeys([
  "MINE",
  "COMMUNITY",
  "MOE",
  "APP",
  "EXTERNAL_RESOURCES",
]);

export const WEBSITE_LOCATION_TYPE = [
  {
    label: "search_filter_location_external_resources_label",
    value: LOCATION_TYPE_VALUE.EXTERNAL_RESOURCES,
  },
];

export const APP_LOCATION_TYPE = [
  { label: "search_filter_location_app_label", value: LOCATION_TYPE_VALUE.APP },
];

export const STUDENT_LOCATION_TYPE = [
  { label: "search_filter_location_mydrive_label", value: LOCATION_TYPE_VALUE.MINE },
  { label: "search_filter_location_moe_label", value: LOCATION_TYPE_VALUE.MOE },
  { label: "search_filter_location_app_label", value: LOCATION_TYPE_VALUE.APP },
];

export const LOCATION_TYPE = [
  { label: "search_filter_location_mydrive_label", value: LOCATION_TYPE_VALUE.MINE },
  { label: "search_filter_location_cg_label", value: LOCATION_TYPE_VALUE.COMMUNITY },
  { label: "search_filter_location_moe_label", value: LOCATION_TYPE_VALUE.MOE },
  { label: "search_filter_location_app_label", value: LOCATION_TYPE_VALUE.APP },
  {
    label: "search_filter_location_external_resources_label",
    value: LOCATION_TYPE_VALUE.EXTERNAL_RESOURCES,
  },
];

export const RESOURCE_TYPE_VALUE = reflectKeys([
  "LESSON",
  "QUESTION",
  "RUBRIC",
  "MEDIA",
  "APP",
  "WEBSITE",
]);

export const RESOURCE_TYPE = [
  { label: "search_filter_resource_type_lesson_course_label", value: RESOURCE_TYPE_VALUE.LESSON },
  { label: "search_filter_resource_type_question_label", value: RESOURCE_TYPE_VALUE.QUESTION },
  { label: "search_filter_resource_type_rubric_label", value: RESOURCE_TYPE_VALUE.RUBRIC },
  { label: "search_filter_resource_type_media_label", value: RESOURCE_TYPE_VALUE.MEDIA },
  { label: "search_filter_resource_type_app_label", value: RESOURCE_TYPE_VALUE.APP },
  { label: "search_filter_resource_type_websites_label", value: RESOURCE_TYPE_VALUE.WEBSITE },
];

export const QUESTION_TYPE = reflectKeys([
  "MCQ",
  "MRQ",
  "REC",
  "FREE",
  "FILE",
  "FILL",
  "DND",
  "EEQ",
  "MPQ",
]);

export const QUESTION_RESOURCE_TYPE_ARRAY = [
  "MCQ",
  "MRQ",
  "REC",
  "FREE",
  "FILE",
  "FILL",
  "DND",
  "EEQ",
  "MPQ",
];

export const QUESTION_ARRAY = ["MCQ", "MRQ", "FILL", "DND", "FREE", "FILE", "REC", "EEQ", "MPQ"];

export const QUESTION_RESOURCE_TYPE_OPTIONS = [
  { label: "search_filter_mcq_label", value: "1", name: "MCQ" },
  { label: "search_filter_mrq_label", value: "2", name: "MRQ" },
  { label: "search_filter_fitb_label", value: "3", name: "FILL" },
  { label: "search_filter_cnd_label", value: "4", name: "DND" },
  { label: "search_filter_frq_label", value: "5", name: "FREE" },
  { label: "search_filter_fsq_label", value: "6", name: "FILE" },
  { label: "search_filter_arq_label", value: "7", name: "REC" },
  { label: "search_filter_eeq_label", value: "8", name: "EEQ" },
  { label: "search_filter_mpq_label", value: "9", name: "MPQ" },
];

export const LESSON_TYPE_LABEL = {
  COURSE: "search_filter_lesson_type_course_label",
  LESSON: "search_filter_lesson_type_lesson_label",
};

export const LESSON_TYPE_OPTIONS = [
  { label: "search_filter_all_label", value: "0", name: "ALL" },
  { label: "search_filter_lesson_type_lesson_label", value: "1", name: "LESSON" },
  { label: "search_filter_lesson_type_course_label", value: "2", name: "COURSE" },
];

export const LESSON_TYPE_ARRAY = ["ALL", "LESSON", "COURSE"];

export const LESSON_PACKAGE_TYPE_ARRAY = ["NEW", "HTML5", "URL"];

export const COURSE_PACKAGE_TYPE_ARRAY = ["COURSE"];

export const COPY_ACTION_TYPE = reflectKeys([
  "COPY_NODE",
  "COPY_LESSON",
  "COPY_ASSIGNMENT_LESSON",
  "COPY_MOE_LESSON",
]);

export const MEDIA_RESOURCE_TYPE_OPTIONS = [
  { label: "search_filter_media_type_image_label", value: "1", name: "IMAGE" },
  { label: "search_filter_media_type_video_label", value: "2", name: "VIDEO" },
  { label: "search_filter_media_type_interactive_label", value: "3", name: "HTML5" },
  { label: "search_filter_media_type_audio_label", value: "4", name: "AUDIO" },
  { label: "search_filter_media_type_ppt_label", value: "5", name: "POWERPOINT" },
  { label: "search_filter_media_type_word_label", value: "6", name: "WORD" },
  { label: "search_filter_media_type_excel_label", value: "7", name: "EXCEL" },
  { label: "search_filter_media_type_pdf_label", value: "8", name: "PDF" },
  { label: "search_filter_media_type_zip_label", value: "9", name: "ZIP" },
  { label: "search_filter_media_type_others_label", value: "10", name: "OTHERS" },
];

export const MEDIA_ARRAY = [
  "IMAGE",
  "VIDEO",
  "HTML5",
  "AUDIO",
  "POWERPOINT",
  "WORD",
  "EXCEL",
  "PDF",
  "ZIP",
  "OTHERS",
];

export const SEARCH_RESOURCE_TYPE_ARRAY = [
  "LESSON",
  "QUESTION",
  "RUBRIC",
  "IMAGE",
  "MCQ",
  "VIDEO",
  "MRQ",
  "HTML5",
  "AUDIO",
  "FILL",
  "DND",
  "FREE",
  "FILE",
  "POWERPOINT",
  "REC",
  "WORD",
  "EXCEL",
  "PDF",
  "ZIP",
  "OTHERS",
  "APP",
  "WEBSITE",
  "EEQ",
  "MULTI_MEDIA",
  "MULTI_QUESTION",
  "MPQ",
  "MEDIA",
];

export const MEDIA_TYPE = reflectKeys([
  "IMAGE",
  "VIDEO",
  "HTML5",
  "AUDIO",
  "POWERPOINT",
  "WORD",
  "EXCEL",
  "PDF",
  "ZIP",
  "OTHERS",
]);

export const TAGGING_ARRAY = ["LESSON", "QUESTION"];

export const SEARCH_PAGE_ARRAY = [
  "LESSON",
  "QUESTION",
  "IMAGE",
  "VIDEO",
  "HTML5",
  "AUDIO",
  "POWERPOINT",
  "WORD",
  "EXCEL",
  "PDF",
  "ZIP",
  "APP",
  "WEBSITE",
  "OTHERS",
];

export const SEARCH_APP_LIBRARY_ARRAY = ["APP"];

export const SEARCH_EXTERNAL_RESOURCES_ARRAY = ["WEBSITE"];

export const SEARCH_MODE = reflectKeys([
  "VIEW", // Global search
  "SINGLE_SELECTION",
  "MULTI_SELECTION",
  "MULTI_SELECTION_COMPONENT",
]);

export const SEARCH_RESOURCE_TYPE = reflectKeys(SEARCH_RESOURCE_TYPE_ARRAY);

export const RESULT_CARD_TYPE = reflectKeys([
  "LESSON",
  "MEDIA",
  "QUESTION",
  "RUBRIC",
  "FILE",
  "APP",
  "WEBSITE",
]);

export const SEARCH_DOMAIN = {
  PERSONAL: "PERSONAL",
  MOE: "MOE",
  COMMUNITY: "COMMUNITY",
  ALP_TEMPLATE: "ALP_TEMPLATE",
  ASSIGNMENT: "ASSIGNMENT",
};

export const SORT_OPTIONS_LESSON_ARRAY = [
  {
    name: "search_result_sort_relevance_label",
    value: "relevance",
  },
  {
    name: "search_result_sort_popularity_label",
    value: "viewCount",
  },
  {
    name: "search_result_sort_latest_label",
    value: "modifiedDate",
  },
  {
    name: "search_result_sort_most_voted_label",
    value: "lessonVoteCount",
  },
];

export const SORT_OPTIONS_ARRAY = [
  {
    name: "search_result_sort_relevance_label",
    value: "relevance",
  },
  {
    name: "search_result_sort_latest_label",
    value: "modifiedDate",
  },
];

export const SORT_OPTIONS_APP_ARRAY = [
  {
    name: "search_result_sort_relevance_label",
    value: "relevance",
  },
  {
    name: "search_result_sort_latest_label",
    value: "modifiedDate",
  },
];

export const SORT_OPTIONS_EXTERNAL_RESOURCES_ARRAY = [
  {
    name: "search_result_sort_relevance_label",
    value: "relevance",
  },
  {
    name: "search_result_sort_latest_label",
    value: "modifiedDate",
  },
];

export const RESOURCE_ARRAY = [
  "MINE",
  "COMMUNITY",
  "MOE",
  "SHARE_WITH_ME",
  "APP",
  "EXTERNAL_RESOURCES",
];

export const STUDENT_RESOURCE_ARRAY = ["MINE", "MOE", "APP"];

// not used for display purpose
export const FILTER_OPTIONS = {
  AREA_OF_SEARCH: "Area",
  LOCATION: "Location",
  LOCATIONS: "Location",
  RESOURCE: "Resource",
  RESOURCE_TYPE: "Resource Type",
  SUBJECT: "Subject",
  LEVEL: "Level",
  SYLLABUS: "Syllabus",
  TOPIC: "Topic",
  PARENT_TOPIC: "ParentTopic",
  AUTHOR_AND_COLLABORATORS: "Author",
};

export const NAMESPACE = {
  APP: "app",
  AUTH: "auth",
  SEARCH: "search",
  ATTEMPT: "attempt",
};

export const COMPLETION_STATUS = {
  NEW: "new",
  INCOMPLETE: "incomplete",
  COMPLETED: "completed",
};

export const LESSON_ACTIVITY_INDICATOR_ICON = {
  INTRODUCTION: {
    VIEWABLE: "Introduction32",
    HIDDEN: "IntroductionHidden32",
    DISABLED: "IntroductionDisabled32",
  },
  END: {
    VIEWABLE: "AssignmentEndDisabled32",
    HIDDEN: "AssignmentEndHidden32",
    DISABLED: "AssignmentEndDisabled32",
    COMPLETED: "AssignmentEndCompleted32",
  },
  SECTION: {
    VIEWABLE: "Section32",
    HIDDEN: "SectionHidden32",
    DISABLED: "SectionDisabled32",
    RESTRICTED: "SectionPrereq32",
    COMPLETED: "SectionCompleted32",
  },
  SECTION_END: {
    VIEWABLE: "PageEnd32",
    HIDDEN: "PageEndHidden32",
    DISABLED: "PageEndDisabled32",
    COMPLETED: "PageEndCompleted32",
  },
};

export const SEARCH_USER_ROLE = reflectKeys(["STUDENT", "TEACHER"]);

export const ADD_FROM_LOCATION = reflectKeys(["LIBRARY", "STARRED_RESOURCES"]);

export const RESOURCE_DOMAIN = {
  MOE: "MOE",
  COMMUNITY: "COMMUNITY",
  PERSONAL: "PERSONAL",
  ALP_TEMPLATE: "ALP_TEMPLATE",
  ASSIGNMENT: "ASSIGNMENT",
};

export const RESOURCE_STATUS = reflectKeys([
  "APPROVED",
  "DRAFT",
  "REJECTED",
  "PENDING_APPROVAL",
  "PENDING_UNPUBLISH",
  "UNPUBLISHED",
]);

export const AREA_OF_SEARCH_OPTIONS = [
  { value: "mainField", label: "Title / Description / Tags / Subject / Level" },
  { value: "contentMap", label: "Content Map" },
  { value: "authorCollaborators", label: "Author / Collaborator" },
];

export const ATTEMPTABLE_TYPE = reflectKeys(["LESSON", "ASSIGNMENT_LESSON"]);

export const ATTEMPT_TYPE = reflectKeys(["ATTEMPT", "PREVIEW"]);

export const RESOURCE_ATTEMPT_TYPE = reflectKeys(["LESSON", "ASSIGNMENT", "QUIZ"]);
